import whatsapp from '../assets/img/whatsapp.png'
import { useSiteSettings } from '../contexts/SiteSettingsContext'

export function Whatsapp() {
    // Read phone from shared context — no extra API call
    const settings = useSiteSettings()
    const rawPhone = settings?.whatsapp || settings?.phone || '972508993111'
    const phone = rawPhone.replace(/\D/g, '')

    const onWhatsappClick = () => {
        const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phone}&text&type=phone_number&app_absent=0`
        window.open(whatsappUrl, "_blank")
    }

    return (
        <button className='whatsapp-fab' onClick={onWhatsappClick} aria-label='שלח הודעת WhatsApp'>
            <img src={whatsapp} alt='' />
        </button>
    )
}